"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listYears = listYears;
const datePart_1 = require("./datePart");
/**
 * Zwraca tablicę zawierającą listę lat pomiędzy datami
 * @param startDate data początkowa
 * @param endDate data końcowa
 */
function listYears(startDate, endDate) {
    let y1 = (0, datePart_1.datePart)(startDate, 'y');
    const y2 = (0, datePart_1.datePart)(endDate, 'y');
    const result = [];
    if (y1 && y2) {
        //datePart przy nieprawidłowej dacie zwraca 0
        while (y1 <= y2) {
            result.push(y1);
            y1++;
        }
    }
    return result;
}
//# sourceMappingURL=listYears.js.map